import React from 'react';
import { IMAGES } from '../../constants/artForms';

/**
 * Hero section component with background image and main content
 */
const Hero = () => {
    return (
        <section id="home" className="relative min-h-[800px] md:min-h-screen flex items-center justify-center text-center overflow-hidden">
            {/* Background Image with Overlay */}
            <div 
                className="absolute inset-0" 
                style={{ 
                    backgroundImage: `url('${IMAGES.HERO}')`, 
                    backgroundSize: 'cover', 
                    backgroundPosition: 'top', 
                    backgroundRepeat: 'no-repeat' 
                }}
            >
                <div className="absolute inset-0 bg-black opacity-50"></div>
            </div>

            {/* Content */}
            <div className="relative z-10 p-8 max-w-4xl mx-auto flex flex-col items-center justify-center min-h-[800px] md:min-h-screen">
                <h1 className="text-5xl md:text-7xl font-extrabold text-white leading-tight mb-6 animate-fade-in-up">
                    <span className="block text-gradient-hero">Kalabandhan</span>
                    <span className="block text-white">
                        America's Hub for Indian Classical Arts
                    </span>
                </h1>
                <p className="text-lg md:text-xl text-gray-200 mb-10 animate-fade-in-up delay-200">
                    Join our vibrant community of artists and enthusiasts across America, celebrating and preserving 
                    the rich traditions of Bharatanatyam, Carnatic Music, and more.
                </p>
                <div className="flex flex-col sm:flex-row gap-4 mb-4">
                    <a 
                        href="#bharatanatyam" 
                        className="inline-block bg-white text-purple-800 font-bold py-3 px-8 rounded-full shadow-lg hover:bg-purple-100 transition duration-300 ease-in-out transform hover:scale-105 animate-fade-in-up delay-400"
                    >
                        Explore the community
                    </a>
                </div>
            </div>
        </section>
    );
};

export default Hero;
